import React, { ReactElement } from 'react';

import { TrainingPlaceDataTable } from './TrainingPlaceDataTable';
import { BaseContainer } from '../../../layout/BaseContainer';

export function TrainingPlaceListPage(): ReactElement {
  return (
    <BaseContainer>
      <div className="lists-title">
        <h1>Formations présentielles</h1>
        <h2 className="mt-4 plus">Lieux de formation</h2>
      </div>
      <div className="pt-5">
        <TrainingPlaceDataTable />
      </div>
    </BaseContainer>
  );
}
